module.exports = __webpack_public_path__ + "static/media/palliatieve-zorg-mannelijke-kunstenaar-in-atelier.257651de.jpg";